// Module
var code = "<div class=\"oe-selector\" style=\"{{>visibility}}\">\r\n    <terceraLabel text=\"{{label}}\" visible=\"{{visible}}\" />\r\n\r\n    <div class=\"oe-selector-right\">\r\n        <accountSelector visible=\"{{.visible}}\" enabled=\"{{enabled}}\" selectedItem=\"{{account}}\"/>\r\n    </div>\r\n</div>";
// Exports
export default code;